import React, { useState } from 'react'
import { cancelDocument } from '../services/api'

export default function CancelForm({ empCod, serie, numero, onSuccess }: any) {
  const [user, setUser] = useState('')
  const [motive, setMotive] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!user) return alert('Informe o usuário')
    if (!motive) return alert('Informe o motivo')
    try {
      setLoading(true)
      await cancelDocument(empCod, serie, numero, { user, motive })
      alert('Cancelamento registrado')
      onSuccess && onSuccess()
    } catch (err) {
      console.error(err)
      alert('Erro ao cancelar')
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginLeft: '0.5rem' }}>
      <input value={user} onChange={(e) => setUser(e.target.value)} placeholder="Usuário" />
      <input value={motive} onChange={(e) => setMotive(e.target.value)} placeholder="Motivo" />
      <button type="submit" disabled={loading} style={{ marginLeft: '0.5rem' }}>{loading ? 'Enviando...' : 'Cancelar'}</button>
    </form>
  )
}
